import type { WorkBook } from 'xlsx';

import {
  scanCatalogWorkbook,
  type CatalogSheetRow,
  type CatalogWorklistBuckets,
} from './catalogWorklist';
import type { FlaggedPotfUpcRow } from './types';

/**
 * POTF_UPC* stacked headers join to `PRODUCT NO.` / `UPC CODE`.
 * Flat fixtures may use those joined names directly.
 */
export const POTF_UPC_HEADERS = ['PRODUCT NO.', 'UPC CODE'] as const;

export type PotfUpcAnalysis = CatalogWorklistBuckets<FlaggedPotfUpcRow>;

function toFlaggedPotfUpc(input: CatalogSheetRow): FlaggedPotfUpcRow {
  const upcCode = input.cell('UPC CODE');
  return {
    fileName: input.fileName,
    sheetName: input.sheetName,
    sheetRow: input.sheetRow,
    productLoc: input.cell('PRODUCT LOC'),
    productInt: input.cell('INT'),
    productNumber: input.cell('PRODUCT NO.'),
    upcCode,
    productGroup: input.cell('PRODUCT GROUP'),
    subgroup: input.cell('SUBGROUP'),
    description: input.cell('DESC.'),
    firstSupplier: input.cell('FIRST SUPPLIER'),
    vendorName: input.cell('VENDOR NAME'),
    productStatus: input.cell('PRODUCT STATUS'),
    reasons: [
      {
        id: 'potfUpcPresent',
        column: 'UPC CODE',
        value: upcCode,
      },
    ],
    otherPartNumber: '',
    otherDivisions: '',
  };
}

/**
 * POTF_UPCY: every product row is a POTF item that already has a UPC.
 * Scan all DC tabs — the WJ/WB stems can be empty while WG holds the row.
 */
export function analyzePotfUpc(
  workbook: WorkBook,
  fileName: string,
): PotfUpcAnalysis | null {
  return scanCatalogWorkbook({
    workbook,
    fileName,
    requiredHeaders: POTF_UPC_HEADERS,
    productHeader: 'PRODUCT NO.',
    toFlagged: toFlaggedPotfUpc,
  });
}
